// scss entityEndpoints from './entity/endpoints'
// scss loanEndpoints from './loan/endpoints'
// scss mediaEndpoints from './media/endpoints'
// scss teamEndpoints from './team/endpoints'
import userEndpoints from './user/endpoints'
import entityEndpoints from './entity/endpoints'
// scss userprofileEndpoints from './userprofile/endpoints'
import endpoints from './investoronboarding/endpoints'
import ioInvitationPreviewEndPoints from './ioinvitationpreview/endpoints'
import onBoardingEndPoints from './onboarding/endpoints'

const endPoints = {
   ...entityEndpoints,
  // ...loanEndpoints,
  // ...mediaEndpoints,
  // ...teamEndpoints,
  ...userEndpoints,
  // ...userprofileEndpoints,
  ...endpoints,
  ...ioInvitationPreviewEndPoints,
  ...onBoardingEndPoints,
}

const getEndPoints = (endPoint, id) => {
  if (Array.isArray(endPoint)) {
    return endPoints[endPoint[0]](endPoint[1], id)
  }

  if (!id) {
    const path = endPoints[endPoint](id)
    return path.replace(/\/$/, '')
  }

  return endPoints[endPoint](id)
}

export default getEndPoints
